import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, FileSpreadsheet, Thermometer } from 'lucide-react'; // ✅ Импортируем иконки

const ReportsPage = () => {
    const navigate = useNavigate();

    const reports = [
        {
            title: 'Архив тепловычислителей',
            icon: FileSpreadsheet, // ✅ Передаем сам компонент иконки
            iconColor: 'text-purple-400', // ✅ Цвет для акцента
            desc: 'Формирование печатной формы архива с итогами и накопленными показаниями для всех типов устройств',
            route: '/reports/archive',
            highlight: true
        },


    ];

    return (
        <div className="p-1 space-y-6">
            {/* ✅ Заголовок с иконкой */}
            <h2 className="text-xl sm:text-2xl font-bold text-white mb-6 flex items-center gap-3">
                <ClipboardList className="w-7 h-7 text-blue-400" />
                Отчетные формы
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {reports.map((report, idx) => {
                    // Динамически создаем компонент иконки
                    const IconComponent = report.icon;

                    return (
                        <div
                            key={idx}
                            onClick={() => navigate(report.route)}
                            className={`bg-slate-800 rounded-xl p-4 sm:p-6 border transition cursor-pointer hover:scale-[1.02] duration-200 group ${report.highlight
                                    ? 'border-purple-500/50 hover:border-purple-400 ring-1 ring-purple-500/20'
                                    : 'border-slate-700 hover:border-blue-500/50'
                                }`}
                        >
                            {/* ✅ Рендерим иконку с нужным размером и цветом */}
                            <div className="mb-4">
                                <IconComponent className={`w-8 h-8 ${report.iconColor} group-hover:scale-110 transition-transform duration-200`} />
                            </div>

                            <h3 className="text-white font-semibold mb-2">{report.title}</h3>
                            <p className="text-slate-400 text-sm leading-relaxed">{report.desc}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ReportsPage;